export const ERROR_CODE = {
  TICKET: 'TICKET',
  APP_REACTIVATION_NOT_SUPPORTED: 'APP_REACTIVATION_NOT_SUPPORTED',
  FETCH_ADDON_INTERNAL_ERROR: 'FetchAddonInternalError',
  UPM_PLUGIN_ERROR_TIMEOUT_LICENSE_CHANGE: 'upm.plugin.error.timeout.license.change',
  CONNECT_INSTALL_ERROR_CONFLICTING_MACRO_ALIAS: 'connect.install.error.conflicting.macro.alias',
  CONNECT_INSTALL_ERROR_DEPENDENCIES_FAILED: 'connect.install.error.dependencies.failed',
  UPM_INSTALL_POST_ERROR: 'UPMInstallPostError',
  ECOSYSTEM_APP_DEACTIVATED: 'EcosystemCloudInstallPollFailure-app.deactivated',
  ECOSYSTEM_APP_INSTALL_INPROGRESS: 'EcosystemCloudInstallPollFailure-app.install.inprogress',
  ECOSYSTEM_APP_MISCONFIGURED: 'EcosystemCloudInstallPollFailure-app.misconfigured',
  ECOSYSTEM_ACCOUNT_PENDING_RENEWAL: 'EcosystemCloudInstallPollFailure-account.pending.renewal',
  CONNECT_INSTALL_ERROR_LOCKED: 'connect.install.error.locked',
  CONNECT_PAYMENT_FAILURE_EXCEPTION: 'connect.remote.upm.install.payment.failure.exception',
  CONNECT_DUPLICATE_MACRO_KEYS_EXCEPTION: 'connect.install.error.duplicate.macro.keys'
};